export var SelectVariants = /*#__PURE__*/ function(SelectVariants) {
    SelectVariants["primary"] = "primary";
    SelectVariants["error"] = "error";
    return SelectVariants;
}({});
export var SelectSize = /*#__PURE__*/ function(SelectSize) {
    SelectSize["s"] = "s";
    SelectSize["m"] = "m";
    SelectSize["l"] = "l";
    return SelectSize;
}({});
export var CreatableOptionPosition = /*#__PURE__*/ function(CreatableOptionPosition) {
    CreatableOptionPosition["top"] = "top";
    CreatableOptionPosition["bottom"] = "bottom";
    return CreatableOptionPosition;
}({});
